module.exports = __webpack_public_path__ + "img/boxianqiantanhuang.prt.c69892ea.jpg";